import { useSecureGraphqlQuery } from '@psyomics/ui-common';

import { GetReportPdfUrlDocument, GetReportPdfUrlQuery, GetReportPdfUrlQueryVariables } from '../generated/report';

const useReportPdfUrlQuery = ({ referralSessionId }: { referralSessionId?: string }) => {
  const [{ data, fetching }, executeQuery] = useSecureGraphqlQuery<GetReportPdfUrlQuery, GetReportPdfUrlQueryVariables>(
    {
      query: GetReportPdfUrlDocument,
      pause: true,
      variables: {
        input: {
          referralSessionId: referralSessionId ?? '',
        },
      },
    }
  );

  return { data: data?.getReportPDFUrl, fetching, executeQuery };
};

export { useReportPdfUrlQuery };
